import { AutomationChannel } from "@redotech/redo-model/advanced-flow/common";
import type { AiContextLibrary } from "@redotech/redo-model/ai-context-library";
import {
  AiContextLibrarySchema,
  AiContextLibraryType,
  qualityValues,
} from "@redotech/redo-model/ai-context-library";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const AutomationChannelValues = [
  AutomationChannel.Email,
  AutomationChannel.SMS,
] as const;

const createContextLibraryItemInputSchema_ = z.object({
  type: z.nativeEnum(AiContextLibraryType),
  title: z.string(),
  content: z.string(),
  marketingAgentPromptIds: z.array(zExt.objectId()),
  smsTemplateId: zExt.objectId().optional(),
  channel: createEnum(AutomationChannelValues),
  quality: createEnum(qualityValues),
  feedback: z.string().optional(),
  useShopperAi: z.boolean().optional(),
  shopperAiDiscountId: zExt.objectId().nullish(),
});

export interface CreateContextLibraryItemInput
  extends z.infer<typeof createContextLibraryItemInputSchema_> {}
export const createContextLibraryItemInputSchema: z.ZodType<CreateContextLibraryItemInput> =
  createContextLibraryItemInputSchema_;

export const createContextLibraryItem = {
  name: "createContextLibraryItem" as const,
  input: createContextLibraryItemInputSchema,
  output: AiContextLibrarySchema as z.ZodType<AiContextLibrary>,
};
